import { isToday, isTomorrow } from 'date-fns';

import { formatDate } from '../utils/helpers';

export const getDateGroup = (date) => {
  return (
    (isToday(date) && `TODAY ${formatDate(date, 'LL.dd.yy').toUpperCase()}`) ||
    (isTomorrow(date)
      ? `TOMORROW ${formatDate(date, 'LL.dd.yy').toUpperCase()}`
      : !isToday(date) && !isTomorrow(date) && formatDate(date, 'EEEE LL.dd.yy').toUpperCase())
  );
};
